import React, { FunctionComponent, ReactNode } from 'react';
import SidebarNavGroup from 'ui/molecules/sidebar-group/sidebar-nav-group';
import { useDispatch } from 'store/hooks';
import { push } from 'connected-react-router';

const NavLink: FunctionComponent<{
  link: string | null;
  active?: boolean;
  children: ReactNode;
  wide?: boolean;
}> = ({ children, link, active, wide }) => {
  const dispatch = useDispatch();
  return (
    <SidebarNavGroup.Link onClick={() => link && dispatch(push(link))} active={active} wide={wide} disabled={!link}>
      {children}
    </SidebarNavGroup.Link>
  );
};

export default NavLink;
